export const host = window.location.host ?? window.location.hostname ?? process.env.VUE_APP_HOST;

export const appEndpoint = `${process.env.VUE_APP_INSECURE ? 'http' : 'https'}://api.${host}`;
export const appEndpointUrl = `api.${host}`;
export const apiEndpoint = `${appEndpoint}/api`;
export const widgetApiEndpoint = `${process.env.VUE_APP_API_V1_ENDPOINT}/price-comparison-widget/property`;
export const supertokensEndpoint = `${process.env.VUE_APP_SUPERTOKENS_URL}/auth`;

export const appDnsRecordValue = `${process.env.VUE_APP_HOST_DNS_URL}`;
export const appApiDnsRecordValue = `api.${process.env.VUE_APP_HOST_DNS_URL}`;

export const invoiceApiUrl = process.env.VUE_APP_INVOICE_API_URL;
// FIXME: needed?
export const externalEngineHost = process.env.VUE_APP_EXTERNAL_ENGINE_HOST;
export const externalEngineTpl = process.env.VUE_APP_EXTERNAL_ENGINE_TPL;
export const adminHost = process.env.VUE_APP_HOST;
export const adminHostTpl = process.env.VUE_APP_HOST_TPL;

export const translationToolUrl = process.env.VUE_APP_TRANSLATION_TOOL;
export const translationToolProjects = [
  'neoFront',
  'cancellationRules',
];
export const appVersion = process.env.VUE_APP_VERSION;

export const reservationCCAccessExpire = process.env.VUE_APP_RESERVATION_CC_ACCESS_EXPIRE;

export const quMainFields = [
  'avail',
  'price',
  'osale',
  'commission',
];

export const quMoreFields = [
  'minlos',
  'maxlos',
  'carr',
  'cdep',
  'booking_guarantee',
  'cancellation_policy',
];

export const distanceUnits = ['km', 'm', 'ft', 'mi'];

export const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const channelSettingValues = [
  {
    key: 'ChannelHotelID',
    translateKey: 'channels.propertyId',
  },
  {
    key: 'ChannelUserID',
    translateKey: 'channels.userName',
  },
  {
    key: 'ChannelPassword',
    translateKey: 'channels.password',
  },
  {
    key: 'Terminal ID',
    translateKey: 'channels.terminalId',
  },
  {
    key: 'Set URL',
    translateKey: 'channels.url',
  },
  {
    key: 'Res URL',
    translateKey: 'channels.resUrl',
  },
  {
    key: 'Map URL',
    translateKey: 'channels.mapUrl',
  },
];

export const locales = [
  {
    code: 'en',
    title: 'English',
  },
  {
    code: 'de',
    title: 'Deutsch',
  },
  {
    code: 'tr',
    title: 'Türkçe',
  },
  {
    code: 'pt',
    title: 'Portuguese',
  },
  {
    code: 'ar',
    title: 'Arabic',
  },
  {
    code: 'es',
    title: 'Spanish',
  },
  {
    code: 'fr',
    title: 'French',
  },
  {
    code: 'it',
    title: 'Italian',
  },
  {
    code: 'nl',
    title: 'Dutch',
  },
  {
    code: 'pl',
    title: 'Polish',
  },
  {
    code: 'ro',
    title: 'Romanian',
  },
  {
    code: 'ru',
    title: 'Русский',
  },
  {
    code: 'zh',
    title: 'Chinese',
  },
  {
    code: 'sl',
    title: 'Slovenski jezik, Slovenščina',
  },
  {
    code: 'da',
    title: 'dansk',
  },
  {
    code: 'bg',
    title: 'Bulgarian',
  },
];
export const langCodes = [
  'en', 'de', 'tr', 'fr', 'ru', 'zh', 'pt',
  'it', 'es', 'pl', 'nl', 'ro', 'sl', 'ar',
  'da', 'bg', 'hu',
];

export const langCodesForMoment = [
  'en', 'de', 'tr', 'fr', 'ru', 'pt',
  'it', 'es', 'pl', 'nl', 'ro', 'sl', 'ar',
  'da', 'bg', 'hu',
];

export const timeUnits = ['hour', 'day', 'week', 'month'];
export const dropTimes = ['BeforeArrival', 'AfterBooking', 'AfterConfirmation'];
export const basisTypes = ['FullStay', 'Nights'];
export const cxlRuleTypes = ['Regular', 'NoShow', 'GracePeriod'];

export const cxlRuleTypeOrder = {
  GracePeriod: 1,
  Regular: 2,
  NoShow: 3,
};

export const channelUpdateTypes = [
  {
    id: 0,
    text: 'channels.updateTypeOne',
  },
  {
    id: 1,
    text: 'channels.updateTypeTwo',
  },
  {
    id: 2,
    text: 'channels.updateTypeThree',
  },
  {
    id: 3,
    text: 'channels.updateTypeFour',
  },
];
export const numberFormats = [
  {
    code: 'en-US',
    currency: 'USD',
  },
  {
    code: 'de-DE',
    currency: 'EUR',
  },
  {
    code: 'en-CA',
    currency: 'CAD',
  },
  {
    code: 'fr-CA',
    currency: 'CAD',
  },
  {
    code: 'en-AU',
    currency: 'AUD',
  },
  {
    code: 'nl-NL',
    currency: 'EUR',
  },
  {
    code: 'ja-JP',
    currency: 'JPY',
  },
  {
    code: 'en-NZ',
    currency: 'NZD',
  },
  {
    code: 'da-DK',
    currency: 'DKK',
  },
  {
    code: 'de-CH',
    currency: 'EUR',
  },
];

export const fakeNumber = 123456789;
export const maxAmountNumber = 2147483647;
export const maxAmountNumberCS = 21474836;

export const bookable = {
  anytime: 0,
  periods: 1,
  fromto: 2,
  until: 3,
  within: 4,
};

export const domainValid = (value) => /^([a-z][a-z0-9-]+)(\.[a-z][a-z0-9-]+)+$/.test(value);

export const widgetId = {
  BookingDay: 0,
  CancellationRate: 1,
  RoomnightsBooking: 2,
  ProducingChannels: 3,
  AvgBookingValue: 4,
  OnlineOccupancyRate: 5,
  AvgDailyRoomRate: 6,
  OnlineRevPAR: 7,
  BookingValue: 8,
  SoldRoomnights: 9,
  IBESearches: 10,
  UniqueVisitors: 11,
  IBEBookings: 12,
  SearchesVisitor: 13,
  Conversion: 14,
  IBEPerformance: 15,
  DirectIndirect: 16,
  BookingTable: 17,
  BookingVolumeTable: 18,
  BookingVolume: 19,
  AccumulatedBookingVolume: 20,
};

export const widgetType = {
  scoreCard: 1,
  gaugeChart: 2,
  pieChart: 3,
  waterfallChart: 4,
  table: 5,
  lineChart: 6,
};

export const positionSplitChar = '-';
export const sizeSplitChar = 'x';
export const arcColors = ['rgb(255,84,84)', 'rgb(239,214,19)', 'rgb(61,204,91)'];

export const timePeriodDashboardKeys = [
  'D-1',
  'D-1_D-7',
  'D-1_D-30',
  'D-1_D-90',
  'D-1_D-365',
  'W-1',
  'YTD-1',
  'YTD-1_LY',
  'M-1',
  'Y-1',
];

export const paymentMethods = {
  sepa: 'sepa_debit',
  card: 'card',
  bank: 'bancontact',
};

export const bankDetails = {
  client: 'CultSwitch GmbH',
  bank: 'Deutsche Bank',
  iban: 'DE68 1007 0000 0048 0921 00',
  bic: 'DEUTDEBBXXX',
};

export const systemList = {
  apaleo: {
    id: Number(process.env.VUE_APP_APALEO_PMS_ID),
    name: 'Apaleo',
  },
  hostaway: {
    id: Number(process.env.VUE_APP_HOSTAWAY_PMS_ID),
    name: 'Hostaway',
  },
};

export const bookingEngineId = process.env.VUE_APP_DEFAULT_PULL_CHANNEL;
export const minPaginationPerPage = 10;

export const defaultProjectId = 1;

export const urlColorInfos = {
  'text-primary': 'tooltipValidatedUrl',
  'text-danger': 'tooltipNotValidatedUrl',
  'text-secondary': 'tooltipExternalEngineUrl',
  'text-muted': 'tooltipSimpleUrl',
};

export const currencySymbols = {
  EUR: '€',
  USD: '$',
  JPY: '¥',
  BGN: 'Лв',
  CZK: 'Kč',
  DKK: 'kr',
  GBP: '£',
  HUF: 'ft',
  LTL: 'LTL',
  LVL: 'LVL',
  PLN: 'zł',
  RON: 'lei',
  SEK: 'kr',
  CHF: 'CHF',
  NOK: 'kr',
  HRK: 'kn',
  RUB: 'RUB',
  TRY: 'TRY',
  AUD: '$',
  BRL: 'R$',
  CAD: '$',
  CNY: '¥',
  HKD: 'HK$',
  IDR: 'Rp',
  ILS: 'ILS',
  INR: 'INR',
  KRW: 'KRW',
  MXN: '$',
  MYR: 'RM',
  NZD: '$',
  PHP: 'PHP',
  SGD: '$',
  THB: 'THB',
  ZAR: 'R',
  EEK: 'EEK',
  SKK: 'SKK',
  EGP: 'ج.م',
  RSD: 'din',
  TND: 'د.ت',
  AED: 'د.إ',
  CLP: '$',
  ARS: '$',
  LBP: 'ل.ل.',
  TZS: 'TSh',
  MAD: 'DH',
  MUR: 'MUR',
  NAD: 'N$',
  PEN: 'S',
  NGN: 'NGN',
  UAH: 'UAH',
  COP: '$',
  VND: 'VND',
  SAR: 'SAR',
  BDT: '৳',
};

export const availableCurrencies = {
  AFN: 'Afghani',
  EUR: 'Euro',
  ALL: 'Lek',
  DZD: 'Algerian Dinar',
  USD: 'US Dollar',
  AOA: 'Kwanza',
  RON: 'Lei',
  XCD: 'East Caribbean Dollar',
  ARS: 'Argentine Peso',
  AMD: 'Armenian Dram',
  FJD: 'Democratic Youth Front',
  MXN: 'Mexican Peso',
  LVL: 'Latvian lats',
  CDF: 'Congolese Franc',
  BBD: 'Barbados Dollar',
  GTQ: 'Quetzal',
  CLP: 'Chilean Peso',
  HNL: 'Lempira',
  ZAR: 'Rand',
  TND: 'Tunisian Dinar',
  CUC: 'Peso Convertible',
  BSD: 'Bahamian Dollar',
  IQD: 'Iraqi Dinar',
  CUP: 'Cuban Peso',
  GMD: 'Dalasi',
  TWD: 'New Taiwan Dollar',
  RSD: 'Serbian Dinar',
  DOP: 'Dominican Peso',
  KMF: 'Comoro Franc',
  MYR: 'Malaysian Ringgit',
  FKP: 'Falkland Islands Pound',
  GEL: 'Lari',
  MAD: 'Moroccan Dirham',
  CVE: 'Cabo Verde Escudo',
  AZN: 'Azerbaijanian Manat',
  SEK: 'Swedish Krona',
  KES: 'Kenyan Shilling',
  UAH: 'Hryvnia',
  BTN: 'Ngultrum',
  GNF: 'Guinea Franc',
  ERN: 'Nakfa',
  IRR: 'Iranian Rial',
  CNY: 'Yuan Renminbi',
  THB: 'Baht',
  MRU: 'Ouguiya',
  BDT: 'Taka',
  LYD: 'Libyan Dinar',
  BMD: 'Bermudian Dollar',
  PHP: 'Philippine Peso',
  KWD: 'Kuwaiti Dinar',
  JMD: 'Jamaican Dollar',
  COP: 'Colombian Peso',
  MKD: 'Denar',
  COU: 'Unidad de Valor Real',
  SGD: 'Singapore Dollar',
  ETB: 'Ethiopian Birr',
  KGS: 'Som',
  LAK: 'Kip',
  BND: 'Brunei Dollar',
  LRD: 'Liberian Dollar',
  CHF: 'Swiss Franc',
  HRK: 'Kuna',
  DJF: 'Djibouti Franc',
  TZS: 'Tanzanian Shilling',
  VND: 'Dong',
  AUD: 'Australian Dollar',
  ILS: 'New Israeli Sheqel',
  GHS: 'Ghana Cedi',
  GYD: 'Guyana Dollar',
  KPW: 'North Korean Won',
  MDL: 'Moldovan Leu',
  BOB: 'Boliviano',
  KHR: 'Riel',
  IDR: 'Rupiah',
  KYD: 'Cayman Islands Dollar',
  TRY: 'Turkish Lira',
  BWP: 'Pula',
  LBP: 'Lebanese Pound',
  JOD: 'Jordanian Dinar',
  HKD: 'Hong Kong Dollar',
  AED: 'UAE Dirham',
  LSL: 'Loti',
  DKK: 'Danish Krone',
  CAD: 'Canadian Dollar',
  BGN: 'Bulgarian Lev',
  BOV: 'Mvdol',
  MMK: 'Kyat',
  NOK: 'Norwegian Krone',
  MUR: 'Mauritius Rupee',
  ROL: 'Romanian leu',
  GIP: 'Gibraltar Pound',
  LKR: 'Sri Lanka Rupee',
  NGN: 'Naira',
  CZK: 'Czech Koruna',
  CRC: 'Costa Rican Colon',
  ANG: 'Netherlands Antillean Guilder',
  HTG: 'Gourde',
  BHD: 'Bahraini Dinar',
  KZT: 'Tenge',
  LTL: 'Lithuanian Litas',
  MVR: 'Rufiyaa',
  INR: 'Indian Rupee',
  KRW: 'Won',
  AWG: 'Aruban Florin',
  JPY: 'Yen',
  MNT: 'Tugrik',
  PLN: 'Zloty',
  GBP: 'Pound Sterling',
  BYN: 'Belarussian Ruble',
  HUF: 'Forint',
  BIF: 'Burundi Franc',
  MWK: 'Kwacha',
  MGA: 'Malagasy Ariary',
  BZD: 'Belize Dollar',
  BAM: 'Convertible Mark',
  EGP: 'Egyptian Pound',
  MOP: 'Pataca',
  NAD: 'Namibia Dollar',
  PEN: 'Nuevo Sol',
  NZD: 'New Zealand Dollar',
  CLF: 'Unidad de Fomento',
  BRL: 'Brazilian Real',
};

export const cultbookingWebsiteUrl = 'https://www.cultbooking.com';
export const cultBayChannelId = '60114';
export const cultBaySSOUrl = 'https://extranetneo.cultbay.com/signin?token=';
export const defaultGMTField = 'GTM-M5Q4BF6';
export const defaultPriceMultiplier = '1';
export const defaultNumberFormat = 'de-DE';
export const defaultPriceFormatCurrency = 'EUR';
export const defaultMaximumFractionDigits = 2;
export const extranetNeoPmsId = 224;
export const defaultDaySalesAllotment = 'P1D';
export const availableMaximumFractionDigits = [0, 1, 2];

export const defaultLanguage = 'en';

export const priceMultiplierArray = [
  {
    id: '1',
    text: 'channels.allPriceXXX',
  },
  {
    id: '100',
    text: 'channels.allPriceHundredXXX',
  },
  {
    id: '1000',
    text: 'channels.allPriceThousandXXX',
  },
  {
    id: '100000',
    text: 'channels.allPriceLankthXXX',
  },
  {
    id: '1000000',
    text: 'channels.allPriceMillionXXX',
  },
];

export const googleMetaSearchChannelId = 50410;

export const channelsWithEmails = [
  58078, // CultBooking
  50410, // Google Meta search
  124870, // Google ads
  55304, // Gloveler
  130238, // HIBEDS
];

export const identifierChannelKeys = ['ChannelHotelID', 'hotelKey'];

export const defaultIdentifierMap = [
  {
    abbreviation: 'exp',
    name: 'Expedia Quick Connect',
  },
  {
    abbreviation: 'bkg',
    name: 'booking.com',
  },
  {
    abbreviation: 'cb',
    name: 'Cultbay GmbH',
  },
  {
    abbreviation: 'hrs',
    name: 'Hotel Reservation Service (HRS 3.0)',
  },
  {
    abbreviation: 'ehtl',
    name: 'ehotel',
  },
  {
    abbreviation: 'crc',
    name: 'CRC-Pull',
  },
];

export const typesenseConfig = {
  apiKey: process.env.VUE_APP_TYPESENSE_API_KEY,
  host: process.env.VUE_APP_TYPESENSE_HOST,
  port: process.env.VUE_APP_TYPESENSE_PORT,
  protocol: process.env.VUE_APP_TYPESENSE_PROTOCOL,
};

export const bookingComChannelID = 7563;

export const partnerTypes = ['SUPPLIER', 'CHANNEL', 'MARKETPLACE'];

export const defaultDateFormat = 'YYYY-MM-DD';
export const defaultDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';

export const defaultUserDateFormat = 'DD MMM YYYY';

export const defaultUserNumberFormat = 'de-DE';
export const defaultUserNumberMaximumFractionDigits = 2;

export const reservationEmailDateFormat = 'DD MMM YYYY HH:mm:ss';

export const defaultUnlimitedDate = '2099-12-31';

export const calendarTypes = {
  room: 'rooms',
  product: 'products',
  mirror: 'mirror',
  productPlus: 'product_plus',
};

export const explanationBoxStatus = ['DISPLAY', 'DISMISS_IT_FOREVER', 'DISMISS_IT_JUST_NOW_SHOW_IT_AGAIN_NEXT_TIME'];

export const hideExplanationBoxStatusIndex = 1;

export const rootPropertyRoomDBID = 1870115;

export const calendarComponentDateFormat = 'YYYY-MM-DD';

export const rootUserEmail = 'rootuser@roomdb.io';

export const sortableChannelIds = [bookingEngineId, googleMetaSearchChannelId];

export const channelInactiveStatus = 'inactive';

export const defaultPageTitle = 'Extranet';

export const smDeviceWidthBreakpoint = '768';

export const extraKeyName = 'extra';

export const roomTypeKeyName = 'roomType';

export const onlinePresenceTabGoogle = 'google';
export const onlinePresenceTabFreeGoogleBookingLinks = 'google-booking-links';

export const onlinePresenceTabWebsite = 'website';

export const onlinePresenceTabBookingEngine = 'booking-engine';

export const baseLayoutComponentName = 'AppHeader';

export const rootUserAndFollowers = ['reinhard.vogel@cultuzz.com', 'rootuser@roomdb.io'];

export const dynamicTraslationItemIds = {
  default: 1,
  communicationBookingEngine: {
    confirmationEmail: 1,
    cancellationEmail: 2,
    creditCardMessage: 3,
    fullyBookedMessages: 4,
    termsAndConditions: 5,
  },
};

export const propertyGroupGrantedRole = 'PropertyGroupGrantedRole';
export const propertyGroupAdminRole = 'PropertyGroupAdminRole';
export const propertyGroupRootRole = 'RootAdminRole';
export const convertTextToNumber = {
  zero: 0,
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
  ten: 10,
  eleven: 11,
  twelve: 12,
  thirteen: 13,
  fourteen: 14,
  fifteen: 15,
  sixteen: 16,
  seventeen: 17,
  eighteen: 18,
  nineteen: 19,
  twenty: 20,
  twentyone: 21,
  twentytwo: 22,
  twentythree: 23,
  twentyfour: 24,
  thirty: 30,
  forty: 40,
  fifty: 50,
  sixty: 60,
  seventy: 70,
  eighty: 80,
  ninety: 90,
};

export const ccModifyUserAccessList = process.env.VUE_APP_CC_MODIFY_USER_ACCESS_LIST || '';

export default {
  host,
  adminHost,
  adminHostTpl,
  appEndpoint,
  apiEndpoint,
  appEndpointUrl,
  widgetApiEndpoint,
  supertokensEndpoint,
  externalEngineHost,
  externalEngineTpl,
  quMainFields,
  quMoreFields,

  locales,
  weekdays,
  timeUnits,
  dropTimes,
  basisTypes,
  cxlRuleTypes,
  cxlRuleTypeOrder,
  numberFormats,
  fakeNumber,
  maxAmountNumber,
  maxAmountNumberCS,
  bookable,
  domainValid,

  paymentMethods,
  bankDetails,

  widgetId,
  widgetType,

  positionSplitChar,
  sizeSplitChar,
  timePeriodDashboardKeys,

  systemList,
  bookingEngineId,
  minPaginationPerPage,
  defaultProjectId,

  defaultIdentifierMap,

  translationToolUrl,
  translationToolProjects,
  urlColorInfos,
  currencySymbols,
  availableCurrencies,

  cultbookingWebsiteUrl,
  cultBayChannelId,
  cultBaySSOUrl,
  defaultGMTField,

  priceMultiplierArray,
  extranetNeoPmsId,
  channelsWithEmails,

  appVersion,
  typesenseConfig,

  reservationCCAccessExpire,

  calendarTypes,
  defaultNumberFormat,
  defaultPriceMultiplier,
  defaultUserDateFormat,
  defaultUserNumberFormat,
  defaultUserNumberMaximumFractionDigits,
  defaultPriceFormatCurrency,
  availableMaximumFractionDigits,
  defaultLanguage,
  defaultUnlimitedDate,

  explanationBoxStatus,
  hideExplanationBoxStatusIndex,
  calendarComponentDateFormat,
  rootUserEmail,
  channelInactiveStatus,

  sortableChannelIds,
  defaultPageTitle,
  smDeviceWidthBreakpoint,

  extraKeyName,
  roomTypeKeyName,

  onlinePresenceTabGoogle,
  onlinePresenceTabWebsite,
  onlinePresenceTabBookingEngine,
  dynamicTraslationItemIds,
  baseLayoutComponentName,
  rootPropertyRoomDBID,

  invoiceApiUrl,

  propertyGroupGrantedRole,
  propertyGroupAdminRole,
  propertyGroupRootRole,
  convertTextToNumber,
  ccModifyUserAccessList,

  appDnsRecordValue,
  appApiDnsRecordValue,
};
